import { useIntl } from "react-intl";
import styled, { css } from "styled-components";
import { CloseButton } from "src/auth/components/CloseButton/CloseButton";
import { Button } from "src/design-system/components/Button/Button";
import { Rome2rioLogo } from "../../../svg/Rome2rioLogo";
import { color, spacing } from "../../../theme";
import { localeToLanguageCode } from "../../../utils/conversions/languageCode";
import { getHomepageUrl } from "../../../utils/url";
import { SearchBox } from "../SearchBox/SearchBox";
import messages from "./SearchEdit.messages";

type Props = {
  origin?: string;
  destination?: string;
  onCloseClick: () => void;
  onOriginClick: () => void;
  onDestinationClick: () => void;
  onSwitchClick: () => void;
  onSearchClick: () => void;
};

export function SearchEdit(props: Props) {
  const intl = useIntl();
  const homepageUrl = getHomepageUrl(localeToLanguageCode(intl.locale));

  return (
    <StyledSearchEdit role="dialog" aria-modal="true">
      <LogoContainer href={homepageUrl} addDestinationInSearch>
        <Rome2rioLogo title="logo" tint="pink" dotTint="pink" />
      </LogoContainer>
      <CloseButtonWrapper>
        <CloseButton onClick={props.onCloseClick} />
      </CloseButtonWrapper>
      <SearchBox
        origin={props.origin}
        destination={props.destination}
        onOriginClick={props.onOriginClick}
        onDestinationClick={props.onDestinationClick}
        onSwitchClick={props.onSwitchClick}
      />
      <SearchButtonContainer addDestinationInSearch>
        <SearchButton onSearchClick={props.onSearchClick} />
      </SearchButtonContainer>
    </StyledSearchEdit>
  );
}

type SearchButtonProps = {
  onSearchClick: () => void;
};
function SearchButton({ onSearchClick }: SearchButtonProps) {
  const intl = useIntl();

  return (
    <Button className="w-full" size="large" onPress={onSearchClick}>
      {intl.formatMessage(messages.search)}
    </Button>
  );
}

const StyledSearchEdit = styled.div`
  position: relative;
  background-color: ${color.n10};
  padding: ${spacing.md};
`;

const LogoContainer = styled.a<{ addDestinationInSearch: boolean }>`
  display: block;
  width: 160px;
  margin: auto;
  margin-top: ${spacing.md};
  ${({ addDestinationInSearch }) =>
    addDestinationInSearch &&
    css`
      margin-left: ${spacing.md};
      margin-bottom: ${spacing.xxl};
      & svg {
        height: 24px;
        width: auto;
      }
    `};
`;

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: ${spacing.lg};
  right: ${spacing.lg};
`;

const SearchButtonContainer = styled.div<{ addDestinationInSearch: boolean }>`
  padding: ${spacing.md};
  ${({ addDestinationInSearch }) =>
    addDestinationInSearch &&
    css`
      padding-top: ${spacing.xxxl};
    `};
`;
